import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { BaseControl } from './base';
import { FormFieldSerializedValue, FieldValidators } from '../index';
import { unserializeDate } from './helpers';
import { DateTimeString } from '../../../../core/types';

export class DatetimeControl extends BaseControl {
  unserializeValue(): DateTimeString {
    return this.field.value as DateTimeString;
  }

  serializeValue(formControlValue: DateTimeString): FormFieldSerializedValue {
    if (formControlValue == null) {
      return null;
    }
    return formControlValue;
  }

  getValidatorConstraint(validatorName: keyof FieldValidators): any {
    if (!this.hasValidator(validatorName)) {
      return;
    }

    const validatorConstraint = super.getValidatorConstraint(validatorName);
    switch (validatorName) {
      case 'min':
      case 'max':
        return unserializeDate(validatorConstraint, this.options.dateTimeFormat);
      default:
        return validatorConstraint;
    }
  }

  protected getKnownValidators(): { [key: string]: (...args: any[]) => ValidatorFn } {
    return {
      min: (minConstraint: Date | string) => {
        return (control: AbstractControl): ValidationErrors => {
          if (!control.value || !minConstraint) {
            return null;
          }

          const value = new Date(control.value);
          const minDate = minConstraint instanceof Date ? minConstraint : new Date(minConstraint);

          return value?.getTime?.() >= minDate?.getTime?.() ? null : { min: { valid: false, minDate } };
        };
      },
      max: (maxConstraint: Date | string) => {
        return (control: AbstractControl): ValidationErrors => {
          if (!control.value || !maxConstraint) {
            return null;
          }
          const maxDate = maxConstraint instanceof Date ? maxConstraint : new Date(maxConstraint);
          const value = new Date(control.value);
          return value?.getTime?.() <= maxDate?.getTime?.() ? null : { max: { valid: false, maxDate } };
        };
      },
    };
  }
}
